import { getTrackSource } from "@api/tracks";
import { useContext } from "solid-js";
import { playerContext } from "../..";

const useTrackSource = () => {
	const { player } = useContext(playerContext);

	return async (index = player.track) => {
		const track = player.queue[index];
		if (!track) throw new Error("No active track");
		if (track.source) return track.source;
		switch (track.type) {
			case "TRACK":
				return (await getTrackSource(track.id, track.platform)).url;
		}
	};
};
export default useTrackSource;
